import apiUseCases from "@src/cloud-connect/api";
import { CreateDashboardPayload } from "@src/cloud-connect/api/dashboards-v2/post-create-dashboard-v2";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { Dashboard } from "@src/types/dashboards";

export interface PostCreateDashboardV2Result {
  success: boolean;
  data?: Dashboard;
  error?: string;
}

export const postCreateDashboardV2UseCase = async (
  payload: CreateDashboardPayload,
): Promise<PostCreateDashboardV2Result> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.postCreateDashboardV2(
      namespace,
      payload,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to create dashboard").message,
    };
  }
};
